import { mediaQuery } from '@/utils/mediaQuery';
import styled from '@emotion/styled';
import { rem } from '@mantine/core';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 40px;
  width: 100%;
  margin: auto;

  p {
    color: rgba(40, 40, 40, 0.8);
    font-size: ${rem(16)};
    font-weight: 700;
  }

  & > div {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;

    a {
      text-transform: uppercase;
      color: rgba(40, 40, 40, 1);
      font-size: ${rem(12)};
      font-weight: 600;
      padding: 10px 16px;
      border-radius: 10px;
      background-color: rgba(40, 40, 40, 0.05);
      text-decoration: none;
      flex-shrink: 0;

      &.selected {
        background-color: rgba(40, 40, 40, 0.25);
      }
    }
  }

  ${mediaQuery('xs', true)} {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  ${mediaQuery('sm', true)} {
    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none;
    }

    & > div {
      flex-wrap: nowrap;
    }
  }
`;
